export function initLoadMore() {
    let loadMoreButton = document.getElementById('load-more-button');
    let listArtist = document.querySelector('.archive-grid.artists-grid');

    if (!loadMoreButton || !listArtist) return;

    let numberArtistPerLoad = 6;

    // Tous les artistes
    let cards = Array.from(listArtist.querySelectorAll('.artist-card'));

    if (cards.length === 0) return;

    // J'affiche les 6 premières artistes, on cache le reste
    let visibleCount = numberArtistPerLoad;

    cards.forEach((card, index) => {
        card.classList.toggle('hidden', index >= visibleCount);
    });

    // Si moins de 6 artistes, on masque le bouton
    if (cards.length <= numberArtistPerLoad) {
        loadMoreButton.style.display = 'none';
        return;
    }

    // 2) Au clic sur le bouton, j'affiche les 6 artistes suivantes (max)
    loadMoreButton.addEventListener('click', () => {
        visibleCount = Math.min(visibleCount + numberArtistPerLoad, cards.length);

        cards.forEach((card, index) => {
            card.classList.toggle('hidden', index >= visibleCount);
        });

        // Si tout est affiché, on cache le bouton
        if (visibleCount >= cards.length) {
            loadMoreButton.style.display = 'none';
        }
    });
}